import YMJ_CM75U from "../assets/images/products/YMJ-CM75U.png";
import YMJ_LCM68 from "../assets/images/products/YMJ-LCM68.png";
import YMJ_TP120 from "../assets/images/products/YMJ-TP120.png";
import YMJ_SD15 from "../assets/images/products/YMJ-SD15.png";
import YMJ_RD180 from "../assets/images/products/YMJ-RD180.png";
import YMJ_TD15 from "../assets/images/products/YMJ-TD15.png";
import YMJ_SD240 from "../assets/images/products/YMJ-SD240.png";
import YMJ_RML20_2 from "../assets/images/products/YMJ-RML20+2.png";
import YMJ_STL300 from "../assets/images/products/YMJ-STL300.png";
import YMJ_RDSR20 from "../assets/images/products/YMJ-RDSR20.png";
import YMJ_RBM20e from "../assets/images/products/YMJ-RBM20e.png";
import YMJ_RDSR30 from "../assets/images/products/YMJ-RDSR30.png";


const products = [
    {
        id: "ymj-cm75u", // Unique product ID
        name: "YMJ-CM75U RFID Converting Machine",
        image: YMJ_CM75U, // Replace with your image paths
        features: [
        "The machine is used for RFID lamination and die cutting, 3 layers dry or wet inlay reel to reel production.",
        "Inlay and printed layer with same pitch or different pitch product lamination and die-cutting only need software settings.",
        "Integrate upside, transfer, glue dispensing online, converting, die cutting, testing, and ultrasonic slitting all in one.",
        "Suitable for narrow web reel label, paper card, and hang tags production."
        ],
        tableHeaders: ["Parameter", "Details", "Details", "Thickness"],
        tableData: [
        ["Overall Dimension", "L4820*W1230*H2200mm", "Inner Diameter of Core", "76mm"],
        ["Weight", "2500kg", "Die Cut CD Manual Adjustment Range", "±10mm"],
        ["Power Supply", "AC380V 50/60HZ ( 50-100A )", "Die Cut Accuracy", "±0.3mm"],
        ["Power", "30-50KW", "Lamination Accuracy", "±0.5mm"],
        ["Air Pressure", "6KG/CM²", "Applicable Inlay", "Dry/Wet inlay (Differnt sizes)"],
        ["Air Consumption", "30L/min", "Width of Substrate", "20-200mm"],
        ["Control", "Drive control integration (bus control)", "UPH", "50-80M/min"],
        ["Outer Diameter of Roll", "max. 600mm", "Good Product Yield", "99.9%"],
        ],
    },
    {
        id: "ymj-lcm68", // Unique product ID
        name: "YMJ-LCM68 RFID Converting Machine",
        image: YMJ_LCM68, // Replace with your image paths
        features: [
            "Suitable for 3 layers, dry/wet inlay label converting and die cutting.",
            "Applicable to wet Inlay upsize function products.",
            "Compatible with the main material separation wet Inlay lamination die-cutting function products.",
            "Online reading and writing, detection, glue, and other personalized functions are optional.",
            "Machine has multi-unit of tension and deviation correction systems which ensure the edges neatly, high output, high quality, and high accuracy production of different products."
        ],
        tableHeaders: ["Parameter", "Details", "Details", "Thickness"],
        tableData: [
            ["Overall Dimension", "L4500*W1500*H2100mm", "Control", "Drive control integration (bus control)"],
            ["Weight", "2000kg", "Applicable Material", "PET, paper (Glasin, light-coated paper, double adhesive paper, coated paper, etc.), woven label"],
            ["Power Supply", "AC380V 50/60Hz 60A", "Applicable Inlay", "Dry/Wet inlay (Different sizes)"],
            ["Power", "25KW", "UPH", "30-60M/min"],
            ["Air Supply", "6KG/CM²", "Lamination Accuracy", "±0.3-0.5mm"],
            ["Air Consumption", "50L/min", "Die Cutting Accuracy", "MD ±0.5mm; CD ±0.5mm"]
        ],
    },    
    {
        id: "ymj-tp120", // Unique product ID
        name: "YMJ-TP120 RFID Personalization Machine",
        image: YMJ_TP120, // Replace with your image paths
        features: [
            "RFID personalization machine is suitable for the automatic encoding, UV ink-jet printing, detection, verify, card collection, and calibration of single label such as single hangtag, paper card, ticket card, etc.",
            "The double labels detection function ensures accurate feeding, high-precision belt conveying, and electric eye monitoring which ensure accurate conveying position.",
            "UV ink-jet printing is optional, which will detect the effect of inkjet and content after UV inkjet printing. With multi-station encoding, scanner, and multi-sets of readers to verify the IC information and QR code or IC information and barcode.",
            "Vision system and encoder reader checking is optional, which ensure the accuracy of RFID product."
        ],
        tableHeaders: ["Parameter", "Details", "Details", "Thickness"],
        tableData: [
            ["Overall Dimensions", "L5650*W710*H1430mm", "Width of Tag", "Max. 105mm"],
            ["Weight", "800kg", "For the Material", "Single hang tag, paper card, ticket card, etc."],
            ["Power Supply", "AC 220V/50/60Hz 30A", "UPH", "25K–40K pcs/Hr"],
            ["Power", "6KW", "Good Product Yield", "99.9%"],
            ["Control", "PC", "Ink-jet Precision", "±0.3mm"],
            ["Ink-jet Precision", "±0.3mm", "Ink-jet Width", "54 or 108mm"]
        ],
    },    
    {
        id: "ymj-sd15", // Unique product ID
        name: "YMJ-SD15 RFID Tag Detecting Machine",
        image: YMJ_SD15, // Replace with your image path
        features: [
            "Full auto single RFID tag detecting machine used for detecting single HF/UHF smart labels.",
            "Code-writing and code-reading is optional; two stations readers and writers ensure data accuracy.",
            "Code printer, code scanner, and ink-jet printing for fault labels is optional."
        ],
        tableHeaders: ["Parameter", "Details", "Details", "Thickness"],
        tableData: [
            ["Label Width", "20–120mm", "Weight", "400kg"],
            ["Applicable Material", "Single hang tag, paper card, ticket card, etc.", "Overall Dimension", "L2200*W780*H1500mm"],
            ["UPH", "10K–15K pcs/Hr", "Power Supply", "AC 220V 50/60Hz"],
            ["Control", "PC", "Good Product Yield", "99.99%"],
            ["Power", "3KW", "", ""]
        ],
    },    
    {
        id: "ymj-rd180", // Unique product ID
        name: "YMJ-RD180 RFID Personalized Machine",
        image: YMJ_RD180, // Replace with your image paths
        features: [
            "RD180 is a small personalized machine that is suitable for reading, writing, detecting and NG editing & replacing of roll-to-roll HF/UHF labels.",
            "Can select and add a camera for online detection of QR code/barcode information.",
            "When detecting or writing NG, you can stop to manual editing & replacing or online inkjet dot marking."
        ],
        tableHeaders: ["Parameter", "Details", "Details", "Details"],
        tableData: [
            ["Dimensions", "L1300*W800*H1650", "Good Product Yield", "99.90%"],
            ["Weight", "200kg", "UPH", "Max 15m/min, UHF Max 50000pcs/h, HF Max 15000pcs/h"],
            ["Power Supply", "AC 220V 50/60Hz 14A", "Applicable Material", "RFID label Material: PET, paper; Thickness: liner (0.05-0.17mm); inlay (0.05-0.17mm); facestock (0.05-0.17mm); label (0.05-0.25mm)"],
            ["Power", "3KW", "Feeding Width", "Max 150mm"],
            ["Air Pressure", "6KG/CM^2", "Control System", "PC"]
        ]
    },    
    {
        id: "ymj-td15", // Unique product ID
        name: "YMJ-TD15 Inspection and Bad Mark Printing Machine",
        image: YMJ_TD15, // Replace with your image paths
        features: [
            "TD15 is a machine that is suitable for inspection and bad mark printing of single-row roll-to-roll HF/UHF label or dry & wet inlay.",
            "Can set the pass yield according to different production requirements for detection.",
            "The detected NG products can be marked with inkjet dots online or the machine can be stopped for manual processing."
        ],
        tableHeaders: ["Parameter", "Details", "Details", "Details"],
        tableData: [
            ["Dimensions", "L1300*W800*H1650", "Good Product Yield", "99.90%"],
            ["Weight", "200kg", "UPH", "Max 15m/min, UHF Max 50000pcs/h, HF Max 15000pcs/h"],
            ["Power Supply", "AC 220V 50/60Hz 14A", "Applicable Material", "RFID label Material: PET, paper; Thickness: liner (0.05-0.17mm); inlay (0.05-0.17mm); facestock (0.05-0.17mm); label (0.05-0.25mm)"],
            ["Power", "3KW", "Feeding Width", "Max 150mm"],
            ["Air Pressure", "6KG/CM^2", "Control System", "PC"]
        ]
    },
    {
        id: "ymj-sd240", // Unique product ID
        name: "YMJ-SD240 Web Paper Sheet Tagging and Labelling Machine",
        image: YMJ_SD240, // Replace with your image paths
        features: [
            "The machine applies to web paper sheet tags, hanging tags, cards, and other labelling.",
            "The machine runs at high speed and is stable; layout is optional.",
            "Flexible unloading and loading units, pre-set the output in the system."
        ],
        tableHeaders: ["Parameter", "Details", "Details", "Details"],
        tableData: [
            ["Overall Dimensions", "L4890*W1170*H1650(mm)", "Conveying Accuracy", "± 0.3mm"],
            ["Weight", "1500kg", "UPH", "20M/min"],
            ["Power Supply", "AC380V, 50/60Hz", "Labelling Accuracy", "± 0.5mm"],
            ["Power", "4.5KW", "Label Width", "10-150mm"],
            ["Air Pressure", "6KG/CM^2", "Paper Sheet Size", "200*200mm (Min); 500*500mm (Max)"],
            ["Control", "PLC", "", ""]
        ]
    },
    {
        id: "ymj-rml20+2", // Unique product ID
        name: "YMJ-RML20+2 Multi-Lane Labelling Machine",
        image: YMJ_RML20_2, // Replace with your image paths
        features: [
            "The machine applies to reel label for multi-lanes labelling.",
            "Adopts ultrasonic device to correct deviation, ensuring high labelling precision and excellent quality."
        ],
        tableHeaders: ["Parameter", "Details", "Details", "Details"],
        tableData: [
            ["Inner Diameter of Core", "76mm", "Labelling Accuracy", "± 0.3~0.5mm"],
            ["Outer Diameter of Roll", "600mm", "Control", "PLC"],
            ["Substrate Width", "20~180mm", "Power", "3.5KW"],
            ["Roller Diameter", "200mm", "Power Supply", "AC 220V 50/60Hz"],
            ["Label Roll Diameter (Max)", "350mm", "Overall Dimension", "L1965*W860*H1865mm"],
            ["Label Width (Max)", "150mm", "Weight", "500kg"],
            ["Applicable Material", "Reel labels", "Good Product Yield", "99.9%"],
            ["UPH", "20~35m/min", "", ""]
        ]
    },
    {
        id: "ymj-stl300", // Unique product ID
        name: "YMJ-STL300 Single Tag Labelling Machine",
        image: YMJ_STL300, // Replace with your image paths
        features: [
            "The machine applies to single tag, hang tags, and cards.",
            "High-precision labelling head and production speed, working stable."
        ],
        tableHeaders: ["Parameter", "Details", "Details", "Details"],
        tableData: [
            ["Label Length", "Max. 250mm", "Power Supply", "AC220V 50/60Hz"],
            ["Label Width", "Max. 180mm", "Weight", "300kg"],
            ["Outer Diameter of Core", "Max. 350mm", "Power", "3.5KW"],
            ["Applicable Material", "Single tag, Hanging tags, Cards, etc.", "Air Pressure", "6KG/CM²"],
            ["UPH", "12 pcs/Hr", "Overall Dimensions", "L1700*W900*H1650mm"],
            ["Labelling Accuracy", "± 0.5mm", "Good Product Yield", "99.9%"],
            ["Control", "PLC / PC", "", ""]
        ]
    },
    {
        id: "ymj-rdsr20", // Unique product ID
        name: "YMJ-RDSR20 Reel Label Detection and Relabelling Machine",
        image: YMJ_RDSR20, // Replace with your image paths
        features: [
            "The machine applies to detect if the HF and UHF finished reel label is good or bad, stripping bad labels and relabelling a good label, checking appearance defects.",
            "It is compatible with different thicknesses and widths of the reel label. Internal and external code consistency detection of defective products for inkjet marking."
        ],
        tableHeaders: ["Parameter", "Details", "Details", "Details"],
        tableData: [
            ["UPH", "UHF Detection: 25k pcs/h (Based on 25mm pitch label); ~48000pcs/h", "HF Detection: ~20m/min, 48000pcs/h", "UHF Strip Bad Label and Fill New Label: ~10-20m/min"],
            ["Material", "Label after converting, coated paper, PET", "Material Width: 22~150mm", "Label Max Rolling Diameter: 600mm"],
            ["Applicable Material", "Roll Label (coated paper, adhesive sticker, PET)", "Static Electricity", "<2KW/cm"],
            ["Noise", "<85dB", "Relabelling Accuracy", "±0.5mm"],
            ["Control", "PC", "Power", "6.5KW"],
            ["Voltage", "AC220V/50Hz 30A", "Air Pressure", "0.6~0.8MPa"],
            ["Weight", "300kg", "Overall Dimension", "L2200mm x W900mm x H1810mm"],
            ["Good Product Yield", "99.9%", "", ""]
        ]
    },
    {
        id: "ymj-rbm20e", // Unique product ID
        name: "YMJ-RBM20e Dry Inlay Detection and Editing Machine",
        image: YMJ_RBM20e, // Replace with your image paths
        features: [
            "Suitable for dry inlay bad mark detection and editing.",
            "With manual splicing table for dry inlay cutting and splicing.",
            "Winding adopts servo torque mode to control the tension, dry inlay protect paper will be collected automatically."
        ],
        tableHeaders: ["Parameter", "Details", "Details", "Details"],
        tableData: [
            ["Overall Dimension", "L1300*W750*H1650mm", "Control", "PLC + Servo"],
            ["Weight", "600kg", "Web Width", "20~200mm"],
            ["Power Supply", "AC 380V 50/60Hz 16A", "UPH", "0~50M/MIN"],
            ["Power", "3.5KW", "Max. Outer Diameter", "Max 350mm"],
            ["Air Pressure", "6KG/CM²", "Accuracy", "± 0.1mm"],
            ["Air Consumption", "80L/MIN", "Good Product Yield", "99.9%"]
        ]
    },
    {
        id: "ymj-rdsr30", // Unique product ID
        name: "YMJ-RDSR30 Single-Row Roll-to-Roll Inspection Machine",
        image: YMJ_RDSR30, // Replace with your image paths
        features: [
            "It is a machine suitable for post-processing quality inspection of single-row roll-to-roll printing labels such as high-speed inspection, editing, and replacing.",
            "Optional online camera appearance inspection, or can be connected to an external visual appearance inspection device.",
            "Defective products detected according to different appearance requirements can be directly removed and relabelled online. Alternatively, defective products detected by appearance can be logged in the system without removal or relabelling."
        ],
        tableHeaders: ["Parameter", "Details", "Details", "Details"],
        tableData: [
            ["Dimensions", "L1300*W800*H1650mm", "Pass Yield", "99.90%"],
            ["Weight", "200kg", "UPH", "Max15m/min; UHF: Max 50000pcs/h, HF: Max 15000pcs/h"],
            ["Power Supply", "AC220V 50/60Hz 14A", "Applicable Material", "Material: PET, paper; Thickness: liner (0.05-0.17mm); Inlay (0.05-0.17mm); facestock (0.05-0.17mm); label (0.05-0.25mm)"],
            ["Power", "3KW", "Feeding Width", "Max150mm"],
            ["Air Pressure", "0.6~0.8MPa", "Control System", "PC"]
        ]
    },
    // Add more product objects here
];
export default products;